import React from 'react';
import Modal from '~/app/common/Modal';
import Button from '~/app/common/Button';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';

export type RemoveTaskDialogProps = {
    isOpen: boolean;
    onKeepParts: () => void;
    onRemoveParts: () => void;
    onCancel: () => void;
};

export type RemoveTaskDialogComponent = React.FC<RemoveTaskDialogProps>;

const RemoveTaskDialog: RemoveTaskDialogComponent = ({
    isOpen,
    onKeepParts,
    onRemoveParts,
    onCancel,
}) => {
    const { t } = useTranslation('workorder');

    return (
        <Modal className={classes.dialog} open={isOpen} onClose={onCancel} position="bottom">
            <div className={classes.header}>
                <p className={classes.message}>{t('detail.removeTaskConfirm')}</p>
            </div>
            <div className={classes.actions}>
                <Button className={classes.actionKeepParts} onClick={onKeepParts}>
                    {t('detail.removeTaskKeepParts')}
                </Button>
                <Button className={classes.actionRemoveParts} onClick={onRemoveParts}>
                    {t('detail.removeTaskRemoveParts')}
                </Button>
                <Button className={classes.actionCancel} onClick={onCancel}>
                    {t('detail.removeTaskNo')}
                </Button>
            </div>
        </Modal>
    );
};

export default RemoveTaskDialog;
